// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1928":"1f5976076ccd39fb","2112":"ccfb995853f13a4a","2272":"d0d83a1c9c697735","3868":"44f941d2c7161c76","4161":"a803af20e4cdc27a","7667":"976bb937660bab60"}[chunkId] + ".js";
};